var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFamily = function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.835 6.5a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Zm0 1.667a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Zm8.75 1.666a1.666 1.666 0 1 0 0-3.332 1.666 1.666 0 0 0 0 3.332Zm0 1.667a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667Zm2.083 5v-.417a2.083 2.083 0 1 0-4.167 0v.417H9.835v-.417a3.75 3.75 0 1 1 7.5 0v.417h-1.667Zm-8.333 0v-3.333a2.5 2.5 0 0 0-5 0V16.5H.668v-3.333a4.167 4.167 0 1 1 8.333 0V16.5H7.335Z",
    fill: "#000"
  })));
};
export default SvgFamily;